import { render, staticRenderFns } from "./SendExtre.vue?vue&type=template&id=deb6dbfa"
import script from "./SendExtre.vue?vue&type=script&lang=js"
export * from "./SendExtre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports